import { render, staticRenderFns } from "./ApplicationSubmitRecentComponent.vue?vue&type=template&id=51392230&scoped=true"
import script from "./ApplicationSubmitRecentComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationSubmitRecentComponent.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationSubmitRecentComponent.vue?vue&type=style&index=0&id=51392230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51392230",
  null
  
)

export default component.exports